import React from 'react';

export const PressSection = () => {
  const pressItems = [
    {
      source: "Ynet",
      title: '"הלב שלה כבר לא עמד בזה": תמר הקטנה נפטרה מדום לב באזעקה. סיפור בהשראתה יציל ילדים אחרים',
      date: "13.09.2024",
      link: "https://www.ynet.co.il/news/article/s1i6bacna",
      image: "https://cdn.prod.website-files.com/63d8fee58e897e0396075286/655cc2b1bdc7598a869d1eba_%D7%A9%D7%97%D7%95%D7%A8.png",
      excerpt: '"בזכות הספר תמר מגינה על לבבות הילדים" חודשיים אחרי הפרידה הכואבת, פנתה למננה לירז יוסף'
    },
    {
      source: "אשדודי",
      title: '"מי לא מפחד כמוני מהאזעקה?" ספר ילדים חדש בהשראת סיפורה של הילדה תמר טורפיאשוילי ז״ל',
      date: "15.09.2024",
      link: "https://ashdodi.com/tamar-book-ashdod/",
      image: "https://ashdodi.com/app/themes/ashdodi-news/dist/images/logo.svg",
      excerpt: 'הספר החדש של לירז יוסף: "מי לא מפחד כמוני מהאזעקה", מציג סיפור מרגש שמחנך לאומץ והתמודדות'
    },
    {
      source: "אשדוד נט",
      title: 'במלאת 11 חודשים לזכרה של תמר טורפיאשוילי ז"ל מאשדוד ספר חדש יעזור לילדים להתמודד עם אזעקות בזמן מלחמה',
      date: "13.09.2024",
      link: "https://ashdodnet.com/%D7%97%D7%93%D7%A9%D7%95%D7%AA-%D7%90%D7%A9%D7%93%D7%95%D7%93/%D7%91%D7%9E%D7%9C%D7%90%D7%AA-11-%D7%97%D7%95%D7%93%D7%A9%D7%99%D7%9D-%D7%9C%D7%96%D7%9B%D7%A8%D7%94-%D7%A9%D7%9C-%D7%AA%D7%9E%D7%A8-%D7%98%D7%95%D7%A8%D7%A4%D7%99%D7%90%D7%A9%D7%95%D7%99%D7%9C%D7%99-%D7%96-%D7%9C-%D7%9E%D7%90%D7%A9%D7%93%D7%95%D7%93-%D7%A1%D7%A4%D7%A8-%D7%97%D7%93%D7%A9-%D7%99%D7%A2%D7%96%D7%95%D7%A8-%D7%9C%D7%99%D7%9C%D7%93%D7%99%D7%9D-%D7%9C%D7%94%D7%AA%D7%9E%D7%95%D7%93%D7%93-%D7%A2%D7%9D-%D7%90%D7%96%D7%A2%D7%A7%D7%95%D7%AA-%D7%91%D7%96%D7%9E%D7%9F-%D7%9E%D7%9C%D7%97%D7%9E%D7%94-597577",
      image: "https://upload.wikimedia.org/wikipedia/commons/8/85/%D7%9C%D7%95%D7%92%D7%95_%D7%90%D7%A9%D7%93%D7%95%D7%93_%D7%A0%D7%98.png",
      excerpt: "לילת הספר נכתבה על ידי לירז יוסף, מורה לספרות ומתמטיקה, והוא עוקב אחרי דני, ילד בן 6 שמנסה להתמודד עם פחדיו מאזעקות.הספר מתאר כיצד דני לוקח את צבצב"
    }
  ];

  return (
    <div className="px-8 lg:px-24 py-16">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-center font-bold text-3xl mb-12">כתבו עלינו</h2>
        
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <div className="flex flex-col md:flex-row">
            {pressItems.map((item, index) => (
              <React.Fragment key={index}>
                <a 
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 group hover:opacity-75 transition-opacity duration-300"
                >
                  <div className="p-6 text-center">
                    {/* Press Logo */}
                    <div className="h-16 mb-6 flex items-center justify-center">
                      <img 
                        src={item.image} 
                        alt={item.source}
                        className="h-full object-contain"
                      />
                    </div>
                    
                    {/* Article Info */}
                    <div className="space-y-3">
                      <div className="text-gray-500 text-sm">{item.date}</div>
                      <h3 className="font-bold text-lg">{item.title}</h3>
                      <p className="text-gray-600 line-clamp-3">{item.excerpt}...</p>
                      
                      <div className="text-cBrownDark font-semibold group-hover:underline">
                        לכתבה המלאה ←
                      </div>
                    </div>
                  </div>
                </a>
                
                {/* Separator Line */}
                {index < pressItems.length - 1 && (
                  <div className="hidden md:block w-px bg-gray-200 mx-4 my-6"></div>
                )}
                
                {/* Mobile Separator */}
                {index < pressItems.length - 1 && (
                  <div className="md:hidden w-full h-px bg-gray-200 my-6"></div>
                )}
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}; 